import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['sortedList']

  connect() {
    addEventListener('select-multiple-component:fetchItems-completed', (event) => {
      this.itemsFetched = true
      this.showLoader()
    })

    addEventListener('filters-count-updater:beforeRetrieveCounts', (event) => {
      this.showLoader()
    })
    addEventListener('filters-count-updater:countsUpdated', (event) => {
      this.onCountsUpdated()
    })
    addEventListener('filters-count-updater:afterRetrieveCounts', (event) => {
      this.onCountsUpdated()
    })
  }

  onCountsUpdated() {
    if (!this.itemsFetched) { return }

    this.sortList()
    this.hideLoader()
  }

  showLoader() {
    if (this.hasSortedListTarget) {
      this.sortedListTarget.querySelector('.loader').classList.remove('hidden')
      this.list.classList.add('hidden')
    }
  }

  hideLoader() {
    if (this.hasSortedListTarget) {
      this.sortedListTarget.querySelector('.loader').classList.add('hidden')
      this.list.classList.remove('hidden')
    }
  }

  get list() {
    return this.sortedListTarget.querySelector('ol')
  }

  sortList() {
    const newList = this.list.cloneNode(false)
    newList.classList.remove('hidden')

    const listElements = []
    this.list.childNodes.forEach((element) => {
      if (element.nodeName === 'LI') { listElements.push(element) }
    })

    listElements.sort(function(a, b) {
      return parseInt(a.querySelector('[data-count-number]').dataset.countNumber.replace(/,/g, ''), 10) -
        parseInt(b.querySelector('[data-count-number]').dataset.countNumber.replace(/,/g, ''), 10)
    })

    listElements.forEach((element) => {
      newList.prepend(element)
    })

    this.list.parentNode.replaceChild(newList, this.list)
  }
}
